import { render, staticRenderFns } from "./StaticCcareer.vue?vue&type=template&id=55852208&"
import script from "./StaticCcareer.vue?vue&type=script&lang=js&"
export * from "./StaticCcareer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports